var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLarge = function SvgArrowLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 17 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.711 15.691-1.346 1.346L.613 9.285l1.346-1.346z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.365 17.037-1.384-1.384 8.614-8.614 1.384 1.384z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.226.671.218 15.288-1.079 1.078-.923-.923-.191-13.467z"
  })));
};
export { SvgArrowLarge as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMWVtIiBoZWlnaHQ9IjFlbSIgdmlld0JveD0iMCAwIDE3IDE4IiBmaWxsPSJjdXJyZW50Q29sb3IiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjcxMTAzIDE1LjY5MTRMOC4zNjUxMSAxNy4wMzc0TDAuNjEyNjA0IDkuMjg0ODRMMS45NTg1MiA3LjkzODkyTDkuNzExMDMgMTUuNjkxNFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik04LjM2NTExIDE3LjAzNzRMNi45ODA3NCAxNS42NTNMMTUuNTk0NiA3LjAzOTA4TDE2Ljk3OSA4LjQyMzQ2TDguMzY1MTEgMTcuMDM3NFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik05LjIyNjQ5IDAuNjcwOTYzTDkuNDQzNTggMTUuOTU4OUw4LjM2NTExIDE3LjAzNzRMNy40NDE5NyAxNi4xMTQyTDcuMjUwNzQgMi42NDY3MUw5LjIyNjQ5IDAuNjcwOTYzWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";